import type { SupportedFilterItemOperator } from '@omnea-app/packages/universal/tables/gridModel'

export const PUBLIC_ID_ALLOWED_OPERATORS = ['equals', 'doesNotEqual'] as const satisfies readonly SupportedFilterItemOperator[]

export const ADDRESS_ALLOWED_OPERATORS = [
  'contains',
  'equals',
  'isEmpty',
  'isNotEmpty',
] as const satisfies readonly SupportedFilterItemOperator[]

export const TAGS_ALLOWED_OPERATORS = [
  'equals',
  'doesNotEqual',
  'isAnyOf',
  'isEmpty',
  'isNotEmpty',
] as const satisfies readonly SupportedFilterItemOperator[]

export const TOTAL_SPEND_ALLOWED_OPERATORS = ['>', '>=', '=', '<', '<='] as const satisfies readonly SupportedFilterItemOperator[]

export const DEPARTMENTS_ALLOWED_OPERATORS = [
  'equals',
  'doesNotEqual',
  'isAnyOf',
  'isEmpty',
] as const satisfies readonly SupportedFilterItemOperator[]

export const CATEGORIES_ALLOWED_OPERATORS = [
  'equals',
  'doesNotEqual',
  'isAnyOf',
  'isEmpty',
  'isNotEmpty',
] as const satisfies readonly SupportedFilterItemOperator[]

export const BUSINESS_OWNERS_ALLOWED_OPERATORS = [
  'equals',
  'doesNotEqual',
  'isEmpty',
  'isNotEmpty',
] as const satisfies readonly SupportedFilterItemOperator[]

export const PRIMARY_CONTACT_ALLOWED_OPERATORS = [
  'contains',
  'doesNotContain',
  'equals',
  'doesNotEqual',
] as const satisfies readonly SupportedFilterItemOperator[]

export const SUBSIDIARIES_ALLOWED_OPERATORS = [
  'contains',
  'doesNotContain',
  'equals',
  'doesNotEqual',
  'isAnyOf',
  'isEmpty',
  'isNotEmpty',
] as const satisfies readonly SupportedFilterItemOperator[]

export const COST_CENTERS_ALLOWED_OPERATORS = [
  'contains',
  'doesNotContain',
  'equals',
  'doesNotEqual',
  'isAnyOf',
  'isEmpty',
] as const satisfies readonly SupportedFilterItemOperator[]

export const EXTERNAL_RISK_SCORE_ALLOWED_OPERATORS = [
  '>',
  '<',
  '>=',
  '<=',
  '=',
  '!=',
] as const satisfies readonly SupportedFilterItemOperator[]

export const isAllowedOperator = <T extends SupportedFilterItemOperator>(
  operator: SupportedFilterItemOperator,
  allowed: readonly T[]
): operator is T => (allowed as readonly SupportedFilterItemOperator[]).includes(operator)
